import RadioInput from '@/core/components/inputs/RadioInput/RadioInput';

export default RadioInput;
